import { stylesheet } from 'typestyle';

const styles = stylesheet({
  buttonIcon: {
    display: 'flex',
    width: '60px',
    height: '60px',
    background: '#fefefe',
    border: '1px solid #c7d6e1',
    boxSizing: 'border-box',
    borderRadius: '50px',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default styles;
